import { getOrder } from 'redux/modules/order/selectors';

export const getContainsEntertainingLines = state =>
  getOrder(state)?.containsEntertainingLines || false;
